import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OptionCreateDto } from 'src/app/models/OptionCreateDto';
import { OptionFreeDto } from 'src/app/models/OptionFreeDto';
import { OptionResponseDto } from 'src/app/models/OptionResponseDto';
import { renewOption } from 'src/app/models/renwewOption';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OptionServices {

  PATH_ADD_OPTION_CRM = "/crm/options/";
  PATH_FREE_OPTION_CRM = "/crm/options/free";
  PATH_RENEWAL_OPTION = "/crm/options/renewal";
  PATH_GET_OPTION_BY_BI = "/options/manage-option/get-by-bi/";
  PATH_GET_OPTION_BY_OPE= "/options/manage-option/get-by-ope/";
  PATH_GET_OPTION_BY_VND= "/options/manage-option/get-by-vnd/";
  errorMessage!: string;
  constructor(private readonly http: HttpClient) { }

  postOption(option: OptionCreateDto): Observable<any> {
    const url = environment.host.domaine+this.PATH_ADD_OPTION_CRM
    //const headers = { 'Authorization': 'Bearer my-token', 'My-Custom-Header': 'foobar' };
    const headers = {};

    return this.http.post<any>(url, option, { headers });
  }

  annulerOption(option: OptionFreeDto): Observable<any> {

    
    const url = environment.host.domaine+this.PATH_FREE_OPTION_CRM;
    //const headers = { 'Authorization': 'Bearer my-token', 'My-Custom-Header': 'foobar' };
    const headers = {};

    return this.http.post<any>(url, option, { headers });
  }

  getOptionEnCoursLot(numOpe: string, numBienExt: string): Observable<any> {

    const url = `${environment.host.domaine+this.PATH_GET_OPTION_BY_BI+numOpe}/${numBienExt}`;
    
    return this.http.get<OptionResponseDto>(url);

  }

  getOptionByProgramme(numOpeExt: string): Observable<OptionResponseDto[]> {

    const url = environment.host.domaine+this.PATH_GET_OPTION_BY_OPE+numOpeExt;
   
    return this.http.get<OptionResponseDto[]>(url);

  }

  getOptionByVendeur(numVendeur: string): Observable<OptionResponseDto[]> {

    const url = environment.host.domaine+this.PATH_GET_OPTION_BY_VND+numVendeur;
    
    return this.http.get<OptionResponseDto[]>(url);

  }

  postProlongationOption(renewoption: renewOption): Observable <any>{

    let url = environment.host.domaine+this.PATH_RENEWAL_OPTION;
    // const headers = {'accept':'application/json', 'Content-Type': 'application/json'};
    // const headers = new Headers({ 'accept': 'application/json' , 'Content-Type': 'application/json'});
    const headers = {};
    // .set('content-type', 'application/json')
    // .set('Access-Control-Allow-Origin', '*');
     return this.http.post<any>(url,{  "resi_idoption":renewoption.resi_idoption ,  "resi_source":"Extarnet" , 
     "resi_statutlotcode":852810001, "resi_reconduction":1  }
    , {});
  }
  
}
